import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { useAuth } from "../../context/AuthContext";
import "./index.css";

const Register = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");

  const handleRegister = async (event) => {
    event.preventDefault();

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password,
      );

      const user = userCredential.user;

      console.log("Registered:", user);

      navigate("/dashboard", { replace: true });
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        setError("Email already registered");
      } else if (error.code === "auth/weak-password") {
        setError("Password must be at least 6 characters");
      } else {
        setError("Registration failed. Try again.");
      }
    }
  };

  const { user } = useAuth();
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }
  return (
    <div className="register-container">
      <form
        className="register-form"
        onSubmit={(event) => handleRegister(event)}
      >
        <h1 className="register-main-heading">Register</h1>

        <label>
          Email
          <input
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label>
          Password
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error && <p className="register-error">{error}</p>}

        <button className="register-button" type="submit">
          Register
        </button>

        <p className="go-for-login-instead">
          Have an Account?
          <span className="register-link" onClick={() => navigate("/login")}>
            {" "}
            Login
          </span>
        </p>
      </form>
    </div>
  );
};

export default Register;
